import { useQuery } from "graphql-hooks";
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { PermissionsGate } from '../../utilities/PermissionsGate';
import { ACCESS_VALUES, PageNames } from '../../utilities/constValues';
import Helper from '../../utilities/helper';
import { ContentBlock } from '../Shared/Content/ContentBlock';
import { ContentBody } from '../Shared/Content/ContentBody';
import { ContentHeading } from '../Shared/Content/ContentHeading';
import { ErrorPage } from '../Shared/ErrorPage';
import { Hero } from '../Shared/Hero';
import { Loading } from '../Shared/Loading';
import { MetaTags } from '../Shared/MetaTags';
import { NavigationCardSet } from '../Shared/NavigationCards/NavigationCardSet';
import { PermissionsRequired } from '../Shared/PermissionsRequired';
import { useAPIErrorContext } from '../../contexts/apiErrorContext';

const CMS_QUERY = `query datoQuery {
    pageData: pageChargingStationLocator {
        fieldBodyContent1
        fieldBodyContent2
        fieldHeroTitle
        fieldMapCenterPoint {
            latitude
            longitude
        }
        fieldCardNavigationSectionTitle
        fieldNavigationCards {
            id
            fieldCardTitle
            fieldCardLink
            fieldCardContent
            fieldCardImage {
                alt
                url
                title
            }
        }
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
}`;

export const ChargingStationLocator = () => {
    const { loading, error, data } = useQuery(CMS_QUERY);
    const { trackError } = useAPIErrorContext();
    const location = useLocation();

    React.useEffect(() => {
        Helper.setPagePath(location.pathname);

        const interval = setInterval(() => {
            //hide the footer and some menu items (Submit New Station, Embed Tool, Devloper APIs) in the AFDC widget
            const shadowRoot = document.getElementById('afdc-stations')?.shadowRoot;
            if (shadowRoot) {
                const style = document.createElement('style');
                style.textContent = `
                     #widget-footer,
                     #footer-actions {
                         display: none !important;
                     }
                     
                     #embed-nav-menu-container .nav-menu-item:nth-last-child(5),
                     #embed-nav-menu-container .nav-menu-item:nth-last-child(3),
                     #embed-nav-menu-container .nav-menu-item:nth-last-child(2) {
                        display: none !important;
                     }
                 `;
                shadowRoot.appendChild(style);

                clearInterval(interval);
            };
        }, 500);
        return () => {
            clearInterval(interval);
        };

    }, [location]);

    if (!error && !loading) {
        var latlng = '';
        if (data && data.pageData.fieldMapCenterPoint) {
            latlng = data.pageData.fieldMapCenterPoint.latitude + ',' + data.pageData.fieldMapCenterPoint.longitude;
        }
        var afdcOptions = '{"country": "all", "localeCountry": "US", "path": "/find/nearest", "query": { "location": "' + latlng + '", "country": "US", "fuel": ["ELEC"], "ev_levels": ["all"] }}';

        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.ChargingStationLocator}>
                <Helmet>
                    <script type="text/javascript" async>
                        {`
                            window.afdcStationsOptions = ${afdcOptions};
                        ` }
                    </script>
                    <script type="text/javascript " async defer src="/scripts/widgets.nlr.gov_afdc_station-locator_assets_embed.js"></script>
                </Helmet>
                <Hero pageTitle={data.pageData.fieldHeroTitle} />
                <ContentBlock className="chargingStationLocator">
                    <ContentHeading title={data.pageData.fieldBodyContent1} />
                    <ContentBody>
                        <div id="afdc-stations"><div id="afdc-stations-loading">Loading alternative fueling station locator...</div></div>
                        <div className="provisioning" dangerouslySetInnerHTML={{ __html: data.pageData.fieldBodyContent2 }} />
                    </ContentBody>
                </ContentBlock>
                <NavigationCardSet PageData={data.pageData} />
                <MetaTags seoData={data.pageData.seo} />
            </PermissionsGate>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
